<div class="card">
    <div class="card-body">
        <h5 class="card-title">Tìm kiếm mẫu thiết bị</h5>
        <form [formGroup]="searchForm">
            <div class="row">
                <div class="col">
                    <app-input-text label="Tên" placeholder="Nhập tên" [formGroup]="searchForm" formControlName="nameLike"></app-input-text>
                </div>
                <div class="col">
                    <app-input-select label="Trạng thái" placeholder="Chọn trạng thái" [formGroup]="searchForm" formControlName="status" [optionList]="modelStatusOptionList"></app-input-select>
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-center">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" (click)="searchModel()" [disabled]="loading"><span *ngIf="loading"  class="spinner-border spinner-border-sm"></span>Tìm kiếm</button>
        </div>
    </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <h5 class="card-title">Kết quả tìm kiếm</h5>
        <div class="alert alert-danger" role="alert" *ngIf="error">
          {{error}}
        </div>
        <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Tên</th>
                    <th scope="col">Trạng thái</th>
                    <th scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-primary" *ngIf="hasEditPerm" (click)="insertModel()">Thêm</button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="devModelList && !loading">
                <tr *ngFor="let devModel of devModelList;index as devModelIndex">
                    <td scope="col">{{(devModelPagination.currentPage-1)*devModelPagination.pageSize + devModelIndex+1}}</td>
                    <td scope="col">{{devModel.name}}</td>
                    <td scope="col">{{modelStatusOptionMap[devModel.status]}}</td>
                    <td scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-info" (click)="viewModel(devModel)">Xem</button>
                            <button type="button" class="btn btn-primary" *ngIf="hasEditPerm" (click)="editModel(devModel)">Sửa</button>
                            <button type="button" class="btn btn-danger" *ngIf="hasEditPerm"  (click)="deleteModel(devModel)">Xóa</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <div class="d-flex justify-content-between align-items-center" *ngIf="devModelPagination.pageCount>1 && !loading">
            <nav>
                <ul class="pagination">
                    <li class="page-item" [ngClass]="{'disabled':devModelPagination.currentPage == 1}">
                      <a class="page-link" (click)="devModelPageChange(devModelPagination.currentPage-1)">Trước</a>
                    </li>
                    <li class="page-item" *ngIf="devModelPagination.currentPage > 3">
                      <a class="page-link" (click)="devModelPageChange(1)">1</a>
                    </li>
                  <li class="page-item disabled" *ngIf="devModelPagination.currentPage > 3">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngFor="let page of devModelPagination.pageList"  [ngClass]="{'active':devModelPagination.currentPage == page}">
                    <a class="page-link" (click)="devModelPageChange(page)">{{page}}</a>
                  </li>
                  <li class="page-item disabled" *ngIf="devModelPagination.currentPage < devModelPagination.pageCount - 2">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngIf="devModelPagination.currentPage < devModelPagination.pageCount - 2">
                    <a class="page-link" (click)="devModelPageChange(devModelPagination.pageCount)">{{devModelPagination.pageCount}}</a>
                  </li>
                  <li class="page-item" [ngClass]="{'disabled':devModelPagination.currentPage == devModelPagination.pageCount}">
                    <a class="page-link"  (click)="devModelPageChange(devModelPagination.currentPage+1)">Sau</a>
                  </li>
                </ul>
              </nav>
        </div>
    </div>
</div>

